import {useQuery} from '@tanstack/react-query'

import {getEquipmentTypeFleet} from './api'
import {rentalAssetKeys} from './query-keys'

export function useEquipmentTypeFleet(typeId: string, options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: rentalAssetKeys.typeFleet(typeId),
        queryFn: () => getEquipmentTypeFleet(typeId),
        enabled: options?.enabled ?? Boolean(typeId),
    })
}
